module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui centered container"
  }, [_c('div', {
    staticClass: "ui login form"
  }, [_c('div', {
    class: {
      'ui stacked segment': true, success: _vm.login.success
    }
  }, [_c('h3', {
    staticClass: "ui header"
  }, [_vm._v("\n        Praktikums-Verwaltungs-Datenbank (PVD)\n      ")]), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.login.success),
      expression: "login.success"
    }],
    staticClass: "ui active centered inline login loader"
  }), _vm._v(" "), _c('news-list', {
    class: {
      hide: _vm.login.success
    }
  })], 1), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "disclaimer"
  }, [_c('p'), _c('h2', [_vm._v("Allgemeine Datenschutzerklärung")]), _c('p'), _vm._v(" "), _c('p', [_vm._v("Durch die Nutzung dieser Webseite erklären Sie sich mit der Erhebung, Verarbeitung und Nutzung von Daten gemäß der nachfolgenden Beschreibung einverstanden. Unsere Webseite kann grundsätzlich ohne Registrierung besucht werden. Dabei werden Daten wie beispielsweise aufgerufene Seiten bzw. Namen der abgerufenen Datei, Datum und Uhrzeit zu statistischen Zwecken auf dem Server gespeichert, ohne dass diese Daten unmittelbar auf Ihre Person bezogen werden. Personenbezogene Daten, insbesondere Name, Adresse oder E-Mail-Adresse werden soweit möglich auf freiwilliger Basis erhoben. Ohne Ihre Einwilligung erfolgt keine Weitergabe der Daten an Dritte.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Datenschutzerklärung für Cookies")])]), _vm._v(" "), _c('p', [_vm._v("Unsere Webseite verwendet Cookies. Das sind kleine Textdateien, welche es ermöglichen auf dem Endgerät des Nutzers spezifische, auf den Nutzer bezogene Informationen zu speichern, während er die Webseite nutzt. Cookies ermöglichen es, Applikationseinstellungen für einen Benutzer zu speichern, Nutzungshäufigkeit und Verhaltensweisen der Seitennutzung zu analysieren, aber auch unser Angebot kundenfreundlicher zu gestalten. Cookies bleiben über das Ende einer Browser-Sitzung gespeichert und können bei einem erneuten Seitenbesuch wieder aufgerufen werden. Wenn Sie das nicht wünschen, sollten Sie Ihren Internetbrowser so einstellen, dass er die Annahme von Cookies verweigert - jedoch wird dann der Funktionsumfang der Praktikums-Datenbank eingeschränkt.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-71758297"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared/layout/default.vue
// module id = 361
// module chunks = 0